import { render, staticRenderFns } from "./ShowBox.vue?vue&type=template&id=714f5fc0"
import script from "./ShowBox.vue?vue&type=script&lang=js"
export * from "./ShowBox.vue?vue&type=script&lang=js"
import style0 from "./ShowBox.vue?vue&type=style&index=0&id=714f5fc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports